module.exports = {
  dropbox: require('./dropbox.js'),
  s3: require('./s3.js'),
  url: require('./url.js'),
};



//////////////////
// WEBPACK FOOTER
// ./~/formiojs/src/providers/storage/index.js
// module id = 630
// module chunks = 0